import React from 'react';

const AboutUs: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50">

      <div className="max-w-7xl mx-auto py-16 px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <h1 className="text-3xl font-extrabold text-gray-900 sm:text-4xl">
            About Us
          </h1>
          <p className="mt-4 text-xl text-gray-500">
            Empowering education through technology
          </p>
        </div>

        <div className="mt-12">
          <div className="prose max-w-3xl mx-auto">
            <h2>Our Mission</h2>
            <p>
              At LocalAlly, we believe that education should be accessible, engaging, and effective for everyone. 
              Our platform connects students with quality educational resources and expert teachers to create 
              a seamless learning experience.
            </p>
            
            <h2>Our Story</h2>
            <p>
              Founded in 2026, LocalAlly was created by a team of educators and technologists who saw an 
              opportunity to transform traditional education. We combine cutting-edge technology with 
              proven teaching methodologies to deliver exceptional learning outcomes.
            </p>
            
            <h2>Our Team</h2>
            <p>
              Our team consists of passionate educators, experienced developers, and innovative designers 
              working together to create the best possible learning platform. We're committed to continuous 
              improvement and innovation in educational technology.
            </p>
            
            <h2>Our Values</h2>
            <ul>
              <li><strong>Excellence:</strong> We strive for the highest standards in education and technology.</li>
              <li><strong>Accessibility:</strong> We make quality education available to everyone.</li>
              <li><strong>Innovation:</strong> We continuously improve and adapt to new educational needs.</li>
              <li><strong>Community:</strong> We foster a supportive learning community for students and educators.</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutUs;
